"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Gehe zu Koordinaten. Von {@link gc.gis.widget.GCWidget} abgeleitet, da es nicht wirklich ein Geocoder ist.
 *
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis.module.GCLocator
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen.
 * @param {gc.gis.module.GCLocator} options.module Modul-Instanz
 * @param {Object} options.controls Liste von Controls
 * @param {string} options.id ID
 * @param {string} options.label Label
 * @param {string} options.url URL zum Webservice
 * @param {string} options.type Geocoder-Typ
 * @param {gc.gis.module.GCLocatorGroup} options.group zugehörige Gruppe
 * @param {gc.gis.map.GCMapView} options.map Karte, auf der die Ergebnisse angezeigt werden
 * @param {gc.gis.format} [options.outputFormat={@link gc.gis.format.WKT}]
 * @param {gc.gis.map.GCMapProjection[]} [options.projections] optionale Projektionen für die Koordinaten-Verortung
 *                    angegeben, wenn nicht definiert, dann werden alle Projektionen der Application verwendet
 */
gc.gis.module.GCLocator.Coordinate = function( options )
{
	var self = this;

	gc.gis.assert.isSet( options );
	gc.gis.assert.isSet( options.controls );

	gc.gis.widget.GCWidget.call( this, options );

	this.module              = options.module;
	this.id                  = options.id;
	this.type                = options.type;
	this.label               = options.label;
	this.group               = options.group;
	this.controls            = options.controls;
	this.url                 = options.url;
	this.map                 = options.map;
	this.output_format       = options.outputFormat || gc.gis.format.WKT;
	// ggf. spezielle Projektionen für die Koordinaten-Verortung angegeben, wenn nicht => Projektionen der Map verwenden
	this.projections = options.projections || this.map.getAvailableProjections();
};
gc.gis.module.GCLocator.Coordinate.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.Coordinate.prototype._render = function()
{
	// Container
	this.element = jQuery('<div>', {
		'class': 'gc-widget-panel gc-geocoder-instance'
	});

	for( var i=0; i<this.controls.length; i++ )
	{
		var element_control = this.__renderControl( i );
		this.element.append( element_control );
	}

	return this.element;
};

/**
 * @private
 * @method
 *
 * @param {number} index Index des zu rendernden Controls
 * @return {jQuery}
 */
gc.gis.module.GCLocator.Coordinate.prototype.__renderControl = function( index )
{
	var self = this;
	var config = this.controls[index];

	// Container
	var element_container = jQuery('<div>', {
		'class': 'form-group'
	});

	// Input
	var element_input;
	var element_label;
	if (config.type === 'number')
	{
		element_input = jQuery('<input>', {
			'class': 'form-control control-input',
			type: 'text',
			name: config.param
		});
		if (config.placeholder)
		{
			element_input.attr('placeholder', config.placeholder );
		}
		element_input.attr('size', config.size );
	}
	else if (config.type === 'select')
	{
		element_input = jQuery('<select>', {
			'class': 'form-control control-select'
		});
		this.element_select_crs = element_input;

		this._updateCRSList();
	}
	else if (config.type === 'button') {
		var button = {
			label: config.label,
			tooltip: config.tooltip || config.label,
			type: 'button',
			click: function (evt) {
				self._locate();
			}
		};

		element_input = gc.gis.util.GCFormRenderer.renderControl(button);
	}

	config._element_input = element_input;

	if (config.type !== 'button') {
		// Label
		element_label = jQuery('<label>', {
			html: '<span>' + config.label + '</span> '
		});
		element_label.append(element_input);
		element_container.append(element_label);

		// Event-Handler für Koordinateneingabe
		if (config.type === 'number') {
			element_input.on('keyup', function (evt) {
				var key = evt.keyCode || evt.which;

				try {
					if (jQuery(this).val().length > 0) {
						self._validateControl(index);
					}
					else {
						jQuery(this).parents('.form-group').removeClass('has-error');
					}
					if (key === 13) {
						self._locate();
					}
				}
				catch (err) {
					gc.gis.iface.log.error(this, err);
				}
			});
		}
	}
	else {
		element_container.append(element_input);
	}

	return element_container;
};

/**
 * @protected
 * @method
 */
gc.gis.module.GCLocator.Coordinate.prototype._updateCRSList = function()
{
	if(this.element_select_crs)
	{
		// Liste leeren
		this.element_select_crs.children().remove();

		// Liste befüllen
		for( var i=0; i<this.projections.length; i++ )
		{
			var element_option = jQuery('<option>', {
				text:  this.projections[i].label,
				value: this.projections[i].code
			});
			this.element_select_crs.append(element_option);
		}
	}
};

/**
 * @protected
 * @method
 */
gc.gis.module.GCLocator.Coordinate.prototype._resetControls = function()
{
	for (var i = 0; i < this.controls.length; i++)
	{
		if (control.type === 'number') {
			this.controls[i]._element_input.val('');
		}
	}
};


/**
 * @protected
 * @method
 *
 * @param {string} value Nutzereingabe des X- oder Y-Wertes
 * @return {string}
 */
gc.gis.module.GCLocator.Coordinate.prototype._prepareCoordValue = function (value) {
	if (value) {
		// TODO ggf. Umwandlung Gradmaß in Dezimaldarstellung
		value = value.replace(',', '.').replace(/\.+$/, '');
	}
	return value;
};

/**
 * @protected
 * @method
 *
 * @param {number} index Index des zu validierenden Controls
 * @throws {gc.gis.error.GCError}
 */
gc.gis.module.GCLocator.Coordinate.prototype._validateControl = function( index )
{
	var control = this.controls[index];
	var element = control._element_input;
	var value = element.val();

	if (control.type === 'number')
	{
		var re = /^-?\d+(\.\d+)?$/;
		value = this._prepareCoordValue(value);

		if (!re.test(value)) {
			element.parents('.form-group').addClass('has-error');
			throw new gc.gis.error.GCError('Ungültige Eingabe: keine Zahl');
		}
		else {
			element.parents('.form-group').removeClass('has-error');
		}
	}
};

/**
 * Zoomt zur Koordinate und zeigt einen Marker auf der Karte an.
 *
 * @protected
 * @method
 */
gc.gis.module.GCLocator.Coordinate.prototype._locate = function()
{
	var coords = [];
	var projection = this.element_select_crs.val();
	var invalid = false;

	for (var i = 0; i < this.controls.length; i++)
	{
		try
		{
			this._validateControl(i);
			if (this.controls[i].type === 'number') {
				coords.push(parseFloat(this._prepareCoordValue(this.controls[i]._element_input.val())));
			}
		}
		catch(err)
		{
			invalid = true;
		}
	}
	if(invalid)
	{
		throw new gc.gis.error.GCError('Konnte nicht zu Koordinate springen: ungültige Eingabe.');
	}

	try
	{
		// zuerst Marker setzen, ggf. Exception wenn Pos. außerhalb sichtbaren Bereichs
		this.map.showMarker(coords, coords, {
			projection: projection
		});

		this.map.panTo(coords, projection);
	}
	catch (err)
	{
		if (err instanceof gc.gis.error.GCOutOfMaxExtentError)
		{
			gc.gis.iface.log.info(this, err.message);
		}
		else
		{
			gc.gis.iface.log.error(this, err.message);
		}
	}
};